import React from "react";
import { HiOutlineTrash } from "react-icons/hi";
import { CustomButton } from "./CustomButton";

interface NavigationHeaderProps {
  onBack: () => void;
  backLabel: string;
  showDelete?: boolean;
  onDelete?: () => void;
  deleteLabel?: string;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
  onBack,
  backLabel,
  showDelete = false,
  onDelete,
  deleteLabel,
}) => {
  return (
    <div className="flex items-center justify-between gap-2">
      <CustomButton
        onClick={onBack}
        variant="secondary"
        size="sm"
        icon="arrowLeft"
        tooltip={backLabel}
        title={<span className="hidden sm:inline">{backLabel}</span>}
      />
      {showDelete && onDelete && (
        <CustomButton
          onClick={onDelete}
          variant="secondary"
          size="sm"
          icon={<HiOutlineTrash size={18} />}
          tooltip={deleteLabel}
          title={
            deleteLabel ? (
              <span className="hidden sm:inline">{deleteLabel}</span>
            ) : undefined
          }
          className="text-red-600 enabled:hover:bg-red-50"
        />
      )}
    </div>
  );
};

export default NavigationHeader;
